/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getBudgetPredictionInputSchema = z.object({
	jobTitle: z.string(),
	jobDescription: z.string(),
	locations: z.array(z.object({ name: z.string(), country: z.object({ name: z.string() }) })),
	campaignId: z.string().uuid(),
})

export type GetBudgetPredictionInputSchema = z.infer<typeof getBudgetPredictionInputSchema>
